import InviteModal from './../components/InviteModal.vue';

export const menuItems = (orgId: string | undefined, name: string) => {
  return {
    separator: { isSeparator: true },
    profileName: {
      title: name,
      name: 'profileName',
      href: `/organizations/${orgId}/account/settings#profile`,
      type: 'secondary',
    },
    myAccount: {
      title: 'My Account',
      name: 'myAccount',
      icon: 'general.profile',
      href: `/organizations/${orgId}/account/settings#profile`,
      type: 'secondary',
    },
    settings: {
      title: 'Settings',
      name: 'settings',
      icon: 'general.cog',
      href: `/organizations/${orgId}/account/settings`,
      type: 'secondary',
    },
    workspaceMembers: {
      title: 'Workspace Members',
      name: 'members',
      icon: 'general.workspaceMembers',
      href: `/organizations/${orgId}`,
      type: 'secondary',
    },
    inviteToTeam: {
      title: 'Invite to Team',
      name: 'invite',
      icon: 'general.inviteToTeam',
      action: {
        type: 'modal',
        params: {
          component: InviteModal,
        },
      },
    },
    upgrade: {
      title: 'Upgrade',
      name: 'upgrade',
      icon: 'general.magicWand',
      href: '/account/plans',
      type: 'warning',
    },
    plans: {
      title: 'Plans',
      name: 'plans',
      icon: 'general.plans',
      href: '/account/plans',
      type: 'secondary',
    },
    download: {
      title: 'Download Zight',
      name: 'download',
      icon: 'general.downloadApp',
      href: '/onboarding/downloads',
      type: 'secondary',
    },
    contactSales: {
      title: 'Contact Sales',
      name: 'contact',
      icon: 'general.chat',
      href: 'https://zight.com/contact/',
      type: 'secondary',
    },
    help: {
      title: 'Help',
      name: 'help',
      icon: 'general.help',
      href: 'https://support.zight.com/',
      type: 'secondary',
    },
    signout: {
      title: 'Sign out',
      name: 'signout',
      icon: 'general.signIn',
      href: '/logout',
      type: 'secondary',
    },
  };
};
